module.exports = __webpack_public_path__ + "static/media/funcesp-desktop.26d77e85.jpg";